import React from "react";
import { Sparkles } from "lucide-react";
import { iconMap } from "../../lib/constants";

export const CategoryIcon = ({ iconName, className }) => {
  const Icon = iconMap[iconName] || Sparkles;
  return <Icon className={className} />;
};
